import React, { useState, useRef, useEffect } from "react"
import { css, keyframes } from "@emotion/react"
import {
  wrapper,
  TitleHeader,
  IconButton,
  IconButtonBtn,
  IconButtonDropdown,
  IconButtonOff,
  Banner,
  Tag,
  SectionHeading,
  LogoCard,
} from "../components/defaults/styles/elements"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { color } from "../components/defaults/styles/theme"
import Calendar from "./defaults/assets/svg/calendar.svg"
import Clock from "./defaults/assets/svg/clock.svg"
import Login from "./defaults/assets/svg/login.svg"
import Speaker from "./defaults/assets/svg/speaker.svg"
import Copy from "./defaults/assets/svg/copy.svg"
import CheckSquare from "./defaults/assets/svg/check-square.svg"
import CheckCircle from "./defaults/assets/svg/check-circle.svg"
import Video from "./defaults/assets/svg/video.svg"
import Send from "./defaults/assets/svg/send.svg"
import Loading from "./defaults/assets/svg/rotate-cw.svg"
import Info from "./defaults/assets/svg/info.svg"
import ArrowUpRight from "./defaults/assets/svg/arrow-up-right.svg"
import ArrowDown from "./defaults/assets/svg/arrow-down.svg"
import Off from "./defaults/assets/svg/off.svg"
import GoogleIcon from "./defaults/assets/svg/google.svg"
import ErrorCircle from "./defaults/assets/svg/alert-circle.svg"
import { ArrowRight } from "./defaults/assets/svg/pagination"
import Flags from "../data/raw/flags"
import moment from "moment"
import mq from "./defaults/styles/mediaquerys"
import { PeopleCardInner } from "./main/expcard-people"
import { ExpCardList, ExpCardListItem } from "./main/expcard"
import publishFilter from "./defaults/filters/publish"
import ContactCard from "./contact_card"
import CaseStudyLink from "./main/casestudy-el-link"
import Seo from "./SEO/seo"
import RearviewInline from "./main/rearviewInline"

import {
  getPassphrase,
  getProfile,
  register,
  getConfirmation,
  getBooking,
} from "../services/registration"
import { getUser } from "../services/auth"
import { navigate } from "gatsby"
import RegistrationModal from "./event_registration"
import GetGoogleCalendar from "../services/googleCalendar"

const SidebarCase = ({ children }) => {
  return (
    <div
      css={css`
        margin: 0 0 2em;
        padding: 0 0.5em 2em;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          height: 1px;
          width: 100%;
          bottom: 0;
          left: 0;
          background: ${color.main_dark};
        }
      `}
    >
      {children}
    </div>
  )
}

const BannerElement = ({
  url,
  recordId,
  data,
  registrationState,
  handleRegistrationState,
  openRegistration,
  bookingId,
  registrationNotification,
  rearview,
}) => {
  if (
    Flags.features.live === true &&
    Flags.settings.live.date === data.agenda_start_time.substr(0, 10) &&
    url &&
    !data.agenda_registration &&
    !data.breakout_session &&
    !data.stream_session
  ) {
    // LIVE SESSION: LIVE
    // banner active if live, url is present and it is NOT a breakout session
    return (
      <JoinBanner
        url={url}
        onlyButton
        title="Join the Livestream"
        description="<p>To join this session please click on the <code>Join now</code> button below or head over to the live stream section of this website by clicking on the live button in the upper right hand corner.</p>"
      />
    )
  } else if (
    Flags.features.live === true &&
    Flags.settings.live.date === data.agenda_start_time.substr(0, 10)
  ) {
    return (
      <Banner
        icon={<Info />}
        content={`
            <p><b>This is a on-site only session</b></p>
            <p>This session will unfortunately not be broadcasted or recorded and can only be accessed by in-person attendees.</p>
          `}
        css={css`
          margin-top: 4em;
          z-index: 1;
          position: relative;
        `}
      ></Banner>
    )
  } else if (
    Flags.features.live === true &&
    Flags.settings.live.date === data.agenda_start_time.substr(0, 10) &&
    url
  ) {
    // BREAKOUT SESSION: LIVE
    return (
      <JoinBanner
        url={url}
        title="Join the Session"
        description={`<p>To join this ${
          data.breakout_session ? "session" : "stream"
        } please click on the <code>Join now</code> button below or copy the URL to your browsers‘ search bar and hit ENTER.</p><p>You can access the entire string by activating <i>Show entire URL</i> in the lower part of this box.</p>`}
      >
        <JoinExternal url={url} />
      </JoinBanner>
    )

    // REARVIEW: All Sessions
  } else if (
    Flags.features.rearview &&
    Flags.settings.live.date > data.agenda_start_time.substr(0, 10) &&
    publishFilter(data.agenda_rearview, "publish") &&
    publishFilter(data.agenda_rearview, "publish").length > 0
  ) {
    return (
      <Banner
        icon={<Off />}
        content={`
            <p><b>This Session is Over</b></p>
            <p>EXPO2022 has come and gone, but don’t you worry, the content is forever.</p><p>In fact, we are even adding new features and updated materials to our website on a regular basis, so check out the recording of this session below or head over to our rearview page, where you do have the chance to re-watch nearly the entire EXPO2022.</p>
          `}
        css={css`
          margin-top: 4em;
          z-index: 1;
          position: relative;
        `}
      >
        <div
          css={css`
            margin-left: 1.75em;
            margin-top: 1.5em;
            margin-bottom: 0.5em;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            & > *:not(:last-child) {
              margin-bottom: 1em;
            }
            ${mq[0]} {
              flex-direction: row;
              & > *:not(:last-child) {
                margin-bottom: 0;
                margin-right: 1em;
              }
            }
          `}
        >
          <IconButton
            to={`#rearview`}
            icon={<ArrowDown />}
            name="This Sessions' Rearview"
            css={css`
              color: ${color.white};
            `}
          />
          <IconButton
            to={`/rearview`}
            icon={<ArrowUpRight />}
            name="Rearview Overview"
            css={css`
              color: ${color.main_dark};
              svg {
                stroke: ${color.main_dark};
              }
              &:before {
                background: none;
                border: 1px solid ${color.main_dark};
                ${mq[0]} {
                  border: none;
                }
              }
            `}
          />
        </div>
      </Banner>
    )
  } else if (
    Flags.features.rearview &&
    Flags.settings.live.date > data.agenda_start_time.substr(0, 10)
  ) {
    return (
      <Banner
        icon={<Off />}
        content={`
            <p><b>This Session is Over</b></p>
            <p><i>Unfortunately there is no public recording of this session (yet) available.</i></p>
            <p>However, we do have created a database containing most of the sessions of EXPO2022, which is available right now (and will get constantly updated throughout the coming weeks). To re-watch the recordings click on the button below and check out our rearview page.</p>
          `}
        css={css`
          margin-top: 4em;
          z-index: 1;
          position: relative;
        `}
      >
        <div
          css={css`
            margin-left: 1.75em;
            margin-top: 1em;
            margin-bottom: 0.5em;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            & > *:not(:last-child) {
              margin-bottom: 1em;
            }
            ${mq[0]} {
              flex-direction: row;
              & > *:not(:last-child) {
                margin-bottom: 0;
                margin-right: 1em;
              }
            }
          `}
        >
          <IconButton
            to={`/rearview`}
            icon={<ArrowUpRight />}
            name="Rearview Overview"
          />
        </div>
      </Banner>
    )
  } else if (Flags.settings.live.date > data.agenda_start_time.substr(0, 10)) {
    return (
      <Banner
        icon={<Off />}
        content={`
            <p><b>This Session is Over</b></p>
            <p><i>Please stay tuned for more information soon.</i></p>
            <p>We are currently working on all recordings of this event and will publish them right here and on our rearview page once everything has been finalized.</p>
          `}
        css={css`
          margin-top: 4em;
          z-index: 1;
          position: relative;
        `}
      ></Banner>
    )
  } else {
    // NOT LIVE: All Sessions
    return (
      <>
        {data.agenda_attendee_limit > 0 ? (
          <Banner
            type="lock"
            content={`
              <p><b>Limited seats only:</b></p>
              <p>The host of this session has requested to limit the number of available spots to ${
                data.agenda_attendee_limit
              } participants only.</p>
              ${
                Flags.features.registration && !Flags.features.live
                  ? "<p>To apply please use the application process below and we will get in touch with you once the selection has been finished.<br />In case of an successful application for this session you will be provided you with further details and the dial-in credentials via email.</p>"
                  : Flags.features.live
                  ? "<p>The application phase has been closed.<br />In case of an successful application for this session you will be provided you with further details and the dial-in credentials via email.</p>"
                  : ""
              }
            `}
            css={css`
              margin-top: 4em;
              z-index: 1;
              position: relative;
            `}
          />
        ) : (
          <Banner
            type="info"
            content={`
              <p><b>Join the Session:</b></p>
              <p>As soon as this session is ready on ${moment(
                data.agenda_start_time
              ).format(
                "MMMM, Do"
              )} you will be able to jump to the broadcast right from this spot. Stay tuned!</p>
            `}
            css={css`
              margin-top: 4em;
              z-index: 1;
              position: relative;
            `}
          />
        )}
        {Flags.features.registration && data.agenda_registration ? (
          <Banner
            type="info"
            content={`
              <p><b>${
                data.agenda_attendee_limit > 0 ? "Apply Now" : "Sign Up Now"
              }:</b></p>
              <p>In order to safe a spot for this session please click on the button below and complete your profile.<br/>Additional registrations for other events will make use of those values – so you only have to type them in once.</p>
            `}
            css={css`
              margin-top: 0.5em;
              z-index: 1;
              position: relative;
              max-width: 45em;
              background: ${color.cta_green};
              flex-direction: row;
            `}
          >
            <div
              css={css`
                margin-left: 1.75em;
              `}
            >
              <RegistrationButton
                recordId={recordId}
                data={data}
                openRegistration={openRegistration}
                registrationState={registrationState}
                handleRegistrationState={handleRegistrationState}
                css={css`
                  margin-top: 1em;
                  &:before {
                    background: ${color.main_dark};
                  }
                `}
              />
              {bookingId ? (
                <p
                  css={css`
                    font-size: 0.65em;
                    opacity: 0.4;
                    margin: 0.2em 0.2em 0em;
                  `}
                >
                  Booking ID: {bookingId}
                </p>
              ) : (
                ""
              )}
              {registrationNotification ? (
                <div
                  id="error-message"
                  css={css`
                    scroll-margin-top: 15em;
                  `}
                >
                  <NotificationBanner
                    registrationNotification={registrationNotification}
                    recordId={recordId}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </Banner>
        ) : (
          ""
        )}
      </>
    )
  }
}

const NotificationBanner = ({ registrationNotification, recordId }) => {
  let ticket_type = getUser().ticket_type

  const form_link = `https://airtable.com/shrdsAxVRD8Y3EeA3?prefill_session_id=${recordId}&prefill_ticket_type=${ticket_type}`

  const openForm = () => {
    window.open(form_link)
  }

  return (
    <div
      css={css`
        background: ${color.red};
        padding: 0.75em;
        border-radius: 5px;
        margin-top: 0.2em;
        ${mq[1]} {
          display: flex;
          align-items: flex-start;
        }
      `}
    >
      <div
        css={css`
          font-size: 0.7em;
          color: white;
          margin-bottom: 1em;
          ${mq[1]} {
            margin-bottom: 0;
            margin-right: 1em;
          }
          p {
            margin: 0;
            line-height: 1.6em;
            &:not(:last-of-type) {
              margin-bottom: 0.25em;
            }
          }
        `}
      >
        <p>
          <b>{registrationNotification}</b> Please click on the button next
          to/below this message in order to send your booking request manually
          via our sign-up form or try again later.
        </p>
      </div>
      <IconButtonBtn
        icon={<Send />}
        name="Open Form"
        onClick={openForm}
        css={css`
          color: white;
          z-index: 1;
          flex: 0 0 auto;
          &:before {
            background: ${color.main_dark};
          }
        `}
      />
    </div>
  )
}

const JoinBanner = ({ url, children, onlyButton, title, description }) => {
  return (
    <div css={wrapper}>
      <div
        css={[
          css`
            background: ${color.plue200};
            border-radius: 5px;
            margin-top: 4em;
            z-index: 1;
            position: relative;
            padding: 2em 1.75em;
          `,
        ]}
      >
        <div
          css={css`
            max-width: 35em;
            margin-bottom: 1.5em;
            p {
              margin-bottom: 0;
              font-size: 0.75em;
            }
            code {
              background: rgba(277, 277, 277, 0.3);
              border-radius: 2px;
              font-size: 0.85em;
              padding: 0.15em 0.5em;
              line-height: 1em;
            }
          `}
        >
          <h2
            css={css`
              font-size: 1.2em;
              margin-bottom: 0.5em;
            `}
          >
            {title}
          </h2>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        <div
          css={css`
            display: flex;
            align-items: flex-start;
          `}
        >
          <IconButton
            url={url}
            icon={<Login />}
            name="Join Now"
            css={[
              css`
                display: inline-block;
                &:before {
                  background: ${color.main_dark};
                }
              `,
              !onlyButton
                ? css`
                    flex: 1 0 auto;
                  `
                : "",
            ]}
          />
          {children}
        </div>
      </div>
    </div>
  )
}

const JoinExternal = ({ url }) => {
  const [showUrl, setShowUrl] = useState("")
  const [urlHeight, setUrlHeight] = useState("1.6em")
  const urlContent = useRef(null)

  const toggleShowUrl = () => {
    setShowUrl(showUrl === "" ? "active" : "")
    setUrlHeight(
      showUrl === "active" ? "1.6em" : `${urlContent.current.scrollHeight}px`
    )
  }

  const CopyButton = ({ className, url }) => {
    const [copyState, setCopyState] = useState(false)

    const toggleCopyState = () => {
      if (!copyState) {
        setCopyState(true)
      }
    }

    return (
      <CopyToClipboard text={url} onCopy={() => toggleCopyState()}>
        <button
          className={className}
          css={css`
            background: none;
            border: none;
            width: 1.2em;
            padding: 0;
            cursor: pointer;
            &:focus {
              outline: none;
            }
            svg {
              stroke: white;
              width: 100%;
              height: auto;
            }
          `}
        >
          {!copyState ? <Copy /> : <CheckSquare />}
        </button>
      </CopyToClipboard>
    )
  }

  const ShowEntireUrl = ({ className, clickHandler }) => {
    return (
      <button
        onClick={clickHandler}
        className={className}
        css={css`
          background: rgba(277, 277, 277, 0.3);
          border: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          padding: 0.2em 0.75em;
          cursor: pointer;
          &:focus {
            outline: none;
          }
        `}
      >
        <p
          css={css`
            font-size: 0.6em;
            letter-spacing: 0.03em;
            margin-bottom: 0;
          `}
        >
          Show entire URL
        </p>
      </button>
    )
  }

  return (
    <div
      css={css`
        background: rgba(277, 277, 277, 0.3);
        border-radius: 5px;
        padding: 1.5em;
        margin-left: 1em;
        flex: 0 1 100%;
        position: relative;
      `}
    >
      <p
        ref={urlContent}
        css={css`
          font-family: monospace;
          margin-bottom: 0;
          overflow: hidden;
          word-break: break-all;
          height: ${urlHeight};
          max-width: calc(100% - 2em);
          transition: height 0.4s ease-in-out;
        `}
      >
        {url}
      </p>
      <CopyButton
        url={url}
        css={css`
          position: absolute;
          top: 1em;
          right: 1em;
        `}
      />
      <ShowEntireUrl
        clickHandler={toggleShowUrl}
        css={css`
          position: absolute;
          top: 100%;
        `}
      />
    </div>
  )
}

const Times = ({ start, duration }) => {
  const start_string =
    Flags.settings.timezone.autoConversion === true
      ? moment(start).format("HH:mm")
      : moment(start).utcOffset(Flags.settings.timezone.offset).format("HH:mm")
  const start_string_utc = moment(start).utc().format("h:mm A")

  const end_string =
    Flags.settings.timezone.autoConversion === true
      ? moment(start).add(duration, "seconds").format("HH:mm")
      : moment(start)
          .add(duration, "seconds")
          .utcOffset(Flags.settings.timezone.offset)
          .format("HH:mm")
  const end_string_utc = moment(start)
    .add(duration, "seconds")
    .utc()
    .format("h:mm A")

  const duration_sting = new Date(duration * 1000).toISOString().substr(12, 4)

  const TimeCard = ({ time, utc }) => {
    return (
      <div
        css={[
          css`
            background: ${color.main_dark};
            padding: 1.25em;
            border-radius: 5px;
            color: ${color.main_light};
            flex-direction: column;
            display: inline-flex;
            ${mq[0]} {
              align-items: flex-end;
              padding: 1.25em 1.5em;
            }
          `,
        ]}
      >
        <p
          css={css`
            margin-bottom: 0;
            font-size: 1.75em;
            font-weight: 600;
            letter-spacing: 0.05em;
            line-height: 1em;
          `}
        >
          {time}
        </p>
        <p
          css={css`
            margin-bottom: 0;
            font-size: 0.65em;
          `}
        >
          {utc} UTC
        </p>
      </div>
    )
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        position: relative;
        ${mq[0]} {
          flex-direction: row;
        }
      `}
    >
      <TimeCard time={start_string} utc={start_string_utc} />

      <div
        css={css`
          display: flex;
          align-items: center;
          padding: 0.5em 1.25em;
          flex: 1 0 auto;
          ${mq[0]} {
            transform: rotate(0deg);
            padding: 0 1em;
            justify-content: center;
          }
          svg {
            height: auto;
            width: 0.85em;
            stroke-width: 2px;
          }
          position: relative;
          &:before {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 2px;
            transform: translateY(-50%);
            background: ${color.main_dark};
            ${mq[0]} {
              content: "";
            }
          }
        `}
      >
        <div
          css={css`
            background: ${color.main_light};
            display: flex;
            position: relative;
            align-items: center;
            ${mq[0]} {
              padding: 0 0.25em;
            }
          `}
        >
          <Clock />
          <p
            css={css`
              color: ${color.main_dark};
              margin-bottom: 0;
              font-size: 0.85em;
              font-weight: 500;
              margin-left: 0.35em;
            `}
          >
            {duration_sting}
          </p>
        </div>
      </div>

      <TimeCard time={end_string} utc={end_string_utc} />
    </div>
  )
}

const Tags = ({ tags }) => {
  return (
    <div
      css={css`
        position: relative;
        margin-top: 2em;
      `}
    >
      {tags && tags.length > 0
        ? tags.map((tag, index) => (
            <Tag
              tag={tag}
              key={index}
              dark
              css={[
                css`
                  margin: 0.4em 0 0;
                  &:not(:last-of-type) {
                    margin-right: 0.4em;
                  }
                  /* color: ${["Mobility", "Production", "Enterprise"].includes(
                    tag
                  )
                    ? "white"
                    : color.main_dark}; */
                  background: ${tag === "Mobility"
                    ? color.orange
                    : tag === "Production"
                    ? color.red
                    : tag === "Enterprise"
                    ? color.blue
                    : color.main_dark};
                `,
              ]}
            />
          ))
        : ""}
    </div>
  )
}

const RegistrationButton = ({
  recordId,
  data,
  openRegistration,
  registrationState,
  handleRegistrationState,
  className,
}) => {
  const handleRegistration = () => {
    if (!!getPassphrase && !!getProfile()) {
      register(
        recordId,
        data.agenda_title,
        data.agenda_attendee_limit,
        handleRegistrationState
      )
    } else if (!!getPassphrase) {
      openRegistration()
    } else {
      navigate(`/${Flags.settings.protectedArea.url}/login`)
    }
  }

  const spin = keyframes`
    100% {
      transform: rotate(360deg)
    }
  `

  if (registrationState === "") {
    return (
      <IconButtonBtn
        className={className}
        name={data.agenda_attendee_limit > 0 ? "Apply Now" : "Sign Up Now"}
        icon={<Send />}
        onClick={handleRegistration}
        css={[
          css`
            z-index: 1;
            position: relative;
          `,
        ]}
      />
    )
  } else {
    return (
      <IconButtonOff
        className={className}
        name={
          registrationState === "registered"
            ? "Succesfully Registered"
            : registrationState === "process"
            ? "Registering…"
            : registrationState === "failed"
            ? "Error. Request failed."
            : "Register Now"
        }
        icon={
          registrationState === "registered" ? (
            <CheckCircle />
          ) : registrationState === "process" ? (
            <Loading />
          ) : registrationState === "failed" ? (
            <ErrorCircle />
          ) : (
            <Send />
          )
        }
        css={[
          css`
            z-index: 1;
            position: relative;
            display: inline-block;
          `,
          registrationState === "process"
            ? css`
                svg {
                  animation: ${spin} 1s linear infinite;
                }
              `
            : "",
          registrationState === "failed"
            ? css`
                opacity: 0.5;
              `
            : "",
        ]}
      />
    )
  }
}

const Buttons = ({
  recordId,
  data,
  openRegistration,
  registrationState,
  handleRegistrationState,
  registrationNotification,
  GCalendarURL,
}) => {
  const ButtonsBtn = css`
    z-index: 1;
    position: relative;
    display: inline-block;
  `

  return (
    <div
      css={css`
        padding-top: 1em;
        > :not(:last-child) {
          margin-bottom: 1.25rem;
        }
      `}
    >
      <div>
        <IconButtonDropdown
          name="Add to calendar"
          icon={<Calendar />}
          css={[
            ButtonsBtn,
            Flags.features.live || Flags.features.registration
              ? css`
                  &::before {
                    background: ${color.main_dark};
                  }
                `
              : "",
          ]}
          dropdown={[
            {
              name: "ics-File for Outlook, Apple Calendar, etc. (Recommended)",
              icon: {
                svg: <Calendar />,
              },
              url: `/calendar-feed/expo2022-event-${recordId}.ics`,
            },
            {
              name: "Google Calendar",
              icon: {
                svg: <GoogleIcon />,
                style: "fill",
              },
              url: GCalendarURL,
            },
          ]}
        />
      </div>

      {Flags.features.registration && data.agenda_registration ? (
        <>
          <div>
            <RegistrationButton
              recordId={recordId}
              data={data}
              openRegistration={openRegistration}
              registrationState={registrationState}
              handleRegistrationState={handleRegistrationState}
            />
          </div>
          {registrationNotification ? (
            <a
              href="#error-message"
              css={css`
                display: block;
                color: ${color.red};
                font-size: 0.65em;
                margin-top: -1rem;
                display: flex;
                align-items: center;
                text-decoration: none;
                svg {
                  height: 1em;
                  width: auto;
                  stroke: ${color.red};
                  :first-of-type {
                    margin-right: 0.5em;
                  }
                  :last-of-type {
                    margin-left: 0.5em;
                  }
                }
              `}
            >
              <Info />
              <p
                css={css`
                  margin-bottom: 0;
                `}
              >
                Please see here for further information.
              </p>
              <ArrowRight />
            </a>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      <div>
        {Flags.features.live &&
        data.agenda_dial_in &&
        !(data.agenda_attendee_limit > 0) &&
        Flags.settings.live.date === data.agenda_start_time.substr(0, 10) ? (
          <IconButton
            name="Join this session now"
            icon={<Login />}
            to={data.agenda_dial_in}
            css={[ButtonsBtn]}
          />
        ) : (
          <>
            <IconButtonOff
              name="Join this session now"
              icon={<Login />}
              css={[
                ButtonsBtn,
                css`
                  display: inline-block;
                  &::before {
                    background: ${color.accent_light};
                  }
                `,
              ]}
            />
            <div
              css={css`
                margin-top: 0.5em;
                p {
                  margin-bottom: 0.5em;
                  color: ${color.main_dark};
                  font-size: 0.65em;
                  opacity: 0.5;
                }
              `}
            >
              <p>
                {data.agenda_attendee_limit > 0
                  ? `This event is a "Limited seats only" session. In case of an successful application you will be provided with the login credentials via email.`
                  : data.agenda_dial_in
                  ? `Once the broadcast is active you will be able to directly jump to the live stream via the button above.`
                  : `This session will not be broadcasted and can only be accessed by to in-person attendees.`}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

const People = ({ people }) => {
  return (
    <ExpCardList
      inline
      css={css`
        padding-top: 1em;
        padding-bottom: 1em;
      `}
    >
      {people.map((e, index) => (
        <ExpCardListItemMod key={index}>
          <PeopleCardInner person={e.data} recordId={e.recordId} />
        </ExpCardListItemMod>
      ))}

      <ExpCardListItemMod placeholder_item />
      <ExpCardListItemMod placeholder_item />
      <ExpCardListItemMod placeholder_item />
    </ExpCardList>
  )
}

const ExpCardListItemMod = ({ children, ...props }) => {
  return (
    <ExpCardListItem
      {...props}
      css={css`
        ${mq[2]} {
          flex: 0 0 calc(100% / 2 - 0.75em);
        }
        ${mq[3]} {
          flex: 0 0 calc(100% / 3 - 1em);
        }
      `}
    >
      {children}
    </ExpCardListItem>
  )
}

const Description = ({ data }) => {
  const content = [
    {
      title: "Description",
      subtitle: "An overview of content and participating host/speakers.",
      html: data.agenda_description
        ? data.agenda_description.childMarkdownRemark.html
        : "",
    },
    {
      title: "Agenda & Topics",
      subtitle: "All times CET, Berlin/Germany",
      html: data.agenda_agenda
        ? data.agenda_agenda.childMarkdownRemark.html
        : "",
    },
  ]

  return (
    <div>
      {content && content.length > 0
        ? content.map((e, index) =>
            e.html ? (
              <div key={index}>
                <SectionHeading
                  title={e.title}
                  subtitle={e.subtitle}
                  css={css`
                    margin-bottom: 2em;
                  `}
                />

                <div
                  dangerouslySetInnerHTML={{ __html: e.html }}
                  css={css`
                    margin-bottom: 3rem;
                    max-width: 45rem;
                    p {
                      margin-bottom: 0;
                      font-size: 0.9em;
                      color: ${color.main_dark};
                      &:not(:last-of-type) {
                        margin-bottom: 0.5em;
                      }
                      a {
                        font-size: 1em;
                        color: ${color.main_dark};
                      }
                    }
                    ul {
                      margin-top: 1em;
                      li {
                        font-size: 0.9em;
                        margin-bottom: 0.25em;
                      }
                    }
                  `}
                />
              </div>
            ) : (
              ""
            )
          )
        : ""}
    </div>
  )
}

const Contact = ({ people }) => {
  return (
    <div>
      {people.map((person, index) => (
        <ContactCard
          key={index}
          person={person}
          css={css`
            max-width: 35em;
          `}
        />
      ))}
    </div>
  )
}

const CaseStudy = ({ data }) => {
  if (
    (Flags.features.casestudy === true ||
      Flags.features.casestudy === "plain") &&
    data &&
    data.length > 0 &&
    publishFilter(data, "cs_publish") &&
    publishFilter(data, "cs_publish").length > 0
  ) {
    return (
      <div
        css={css`
          margin-bottom: 3em;
        `}
      >
        <SectionHeading
          title={`Project Teaser`}
          subtitle={`This session is associated with a pilot project that has been developed throughout our most recent STARTUP AUTOBAHN program. The comprehensive overview of this collaboration can be found below.`}
          css={css`
            margin-bottom: 2em;
          `}
        />

        {publishFilter(data, "cs_publish").map(({ data }, index) => (
          <CaseStudyLink
            key={index}
            data={data}
            css={css`
              &:not(:last-child) {
                margin-bottom: 0.75em;
              }
            `}
          />
        ))}
      </div>
    )
  } else {
    return null
  }
}

const Rearview = ({ data }) => {
  if (Flags.features.rearview && data && data.length > 0) {
    return (
      <div
        id="rearview"
        css={css`
          scroll-margin-top: 5em;
        `}
      >
        <TitleHeader
          title={`EXPO2022 Rearview`}
          size="1"
          inline
          transparent
          subtitle={`<p>For a comprehensive overview of all EXPO2022 recordings and to re-watch the entire day please head over to <a href="/rearview">the rearview section</a>.</p>`}
          icon={<Video />}
          css={css`
            padding-top: 2em;
            padding-bottom: 1em;
          `}
        />
        <RearviewInline data={data} narrow />
      </div>
    )
  } else return null
}

const Event = ({ data, recordId }) => {
  const GCalendarURL = GetGoogleCalendar({ node: { data, recordId: recordId } })

  const [registrationOpen, setRegistrationOpen] = useState(false)
  const [registrationState, setRegistrationState] = useState("")
  const [bookingId, setBookingId] = useState("")
  const [registrationNotification, setRegistrationNotification] = useState("")

  const openRegistration = () => {
    setRegistrationOpen(registrationOpen => !registrationOpen)
  }

  const handleRegistrationState = e => {
    setRegistrationState(e)
  }

  useEffect(() => {
    if (getConfirmation(recordId)) {
      handleRegistrationState("registered")
      setBookingId(getConfirmation(recordId))
    }
  }, [recordId, registrationState])

  useEffect(() => {
    if (registrationState === "failed") {
      if (getBooking(recordId).error === "timeout") {
        setRegistrationNotification(
          "EXPO2022 was not able to establish a server connection."
        )
      } else {
        setRegistrationNotification("An unknown error appeared.")
      }
    }
  }, [recordId, registrationState])

  const seo = {
    title: data.agenda_title,
  }

  return (
    <>
      <Seo frontmatter={seo} />
      <TitleHeader
        title={data.agenda_title}
        icon={<Calendar />}
        subtitle={`<p>${
          data.agenda_teaser
            ? data.agenda_teaser
            : "To make sure you do not miss out this session you can easily add it to your calendar by utilizing the button below. As soon as the event is live you will also find the access token right below this information element."
        }</p>`}
        transparent
        css={css`
          h2 {
            max-width: 40rem;
          }
        `}
      />

      <div css={[wrapper, css``]}>
        <IconButtonDropdown
          name="Add to calendar"
          icon={<Calendar />}
          white
          dropdown={[
            {
              name: "ics-File for Outlook, Apple Calendar, etc. (Recommended)",
              icon: {
                svg: <Calendar />,
              },
              url: `/calendar-feed/expo2022-event-${recordId}.ics`,
            },
            {
              name: "Google Calendar",
              icon: {
                svg: <GoogleIcon />,
                style: "fill",
              },
              url: GCalendarURL,
            },
          ]}
        />
      </div>

      <BannerElement
        url={data.agenda_dial_in}
        recordId={recordId}
        data={data}
        openRegistration={openRegistration}
        registrationState={registrationState}
        handleRegistrationState={handleRegistrationState}
        bookingId={bookingId}
        registrationNotification={registrationNotification}
      />

      <div
        css={css`
          background: ${color.main_light};
          padding: 7em 0;
          position: relative;
          margin-top: -2.5rem;
        `}
      >
        <section
          css={[
            wrapper,
            css`
              display: flex;
              flex-direction: column;
              ${mq[2]} {
                flex-direction: row;
              }
            `,
          ]}
        >
          <div
            css={css`
              ${mq[2]} {
                max-width: 23rem;
                flex: 1 0 23rem;
                margin-right: 7em;
              }
              ${mq[3]} {
                margin-right: 10em;
              }
            `}
          >
            <SidebarCase>
              <SectionHeading
                title="Tags"
                subtitle="A glimpse on what to expect."
                css={css`
                  margin-bottom: 1.5em;
                `}
              />
              <Tags tags={data.agenda_tags} />
            </SidebarCase>

            <SidebarCase>
              <SectionHeading
                title="Timing"
                subtitle={`Everything about when to join and leave. ${
                  Flags.settings.timezone.autoConversion === false
                    ? "All timings in " +
                      Flags.settings.timezone.description +
                      " time."
                    : ""
                }`}
                css={css`
                  margin-bottom: 1.5em;
                `}
              />
              <Times
                start={data.agenda_start_time}
                duration={data.agenda_duration}
              />
            </SidebarCase>

            {data.agenda_stage && (
              <SidebarCase>
                <SectionHeading
                  title="Stage"
                  subtitle="In case you‘d like to know where the magic is going to happen."
                  css={css`
                    margin-bottom: 1.5em;
                  `}
                />
                <div
                  css={css`
                    border: 2px solid ${color.plue300};
                    border-radius: 5px;
                    padding: 0.3em 1em 0.25em;
                    display: inline-block;
                    position: relative;
                    min-width: 4em;
                    text-align: center;
                    max-width: 100%;
                    margin-bottom: 2px;
                  `}
                >
                  <p
                    css={css`
                      margin-bottom: 0;
                      line-height: 1.3em;
                      overflow-x: hidden;
                      white-space: nowrap;
                      max-width: 100%;
                      text-overflow: ellipsis;
                      font-size: 0.85em;
                      font-weight: 600;
                      color: ${color.plue300};
                    `}
                  >
                    {data.agenda_stage === "one"
                      ? "ONE"
                      : data.agenda_stage === "two"
                      ? "TWO"
                      : data.agenda_stage === "three"
                      ? "Outside Stage"
                      : data.agenda_stage === "four"
                      ? "Side Events"
                      : data.agenda_stage}
                  </p>
                </div>
              </SidebarCase>
            )}

            {(data.agenda_partners && data.agenda_partners.length > 0) ||
            (data.agenda_startups && data.agenda_startups.length > 0) ? (
              <SidebarCase>
                <SectionHeading
                  title="Partner companies involved"
                  subtitle="The head(s) behind this session"
                  css={css`
                    margin-bottom: 1.5em;
                  `}
                />

                <div
                  css={css`
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                  `}
                >
                  {data.agenda_partners && data.agenda_partners.length > 0
                    ? data.agenda_partners
                        .sort((a, b) => (a.data.name > b.data.name ? 1 : -1))
                        .map((partner, index) => (
                          <LogoCard
                            partner
                            key={index}
                            recordId={partner.recordId}
                            name={partner.data.name}
                            id={partner.id}
                            design={css`
                              background: ${color.main_dark};
                              svg {
                                fill: white;
                              }
                            `}
                          />
                        ))
                    : ""}
                  {data.agenda_startups && data.agenda_startups.length > 0
                    ? data.agenda_startups
                        .sort((a, b) =>
                          a.data.startup > b.data.startup ? 1 : -1
                        )
                        .map((startup, index) => (
                          <LogoCard
                            startup
                            key={index}
                            recordId={startup.recordId}
                            name={startup.data.startup}
                            id={startup.id}
                            passwordProtected={startup.data.password_protected}
                            design={css`
                              background: ${color.main_dark};
                              svg {
                                fill: white;
                              }
                            `}
                          />
                        ))
                    : ""}
                  <LogoCard placeholder />
                  <LogoCard placeholder />
                  <LogoCard placeholder />
                </div>
              </SidebarCase>
            ) : (
              ""
            )}

            <SidebarCase>
              <SectionHeading
                title="More"
                subtitle="Actions and miscellaneous information you might need."
              />
              <Buttons
                recordId={recordId}
                data={data}
                openRegistration={openRegistration}
                registrationState={registrationState}
                handleRegistrationState={handleRegistrationState}
                registrationNotification={registrationNotification}
                GCalendarURL={GCalendarURL}
              />
            </SidebarCase>

            <div
              css={css`
                padding: 0 0.5em;
                p {
                  margin-bottom: 0.5em;
                  color: ${color.main_dark};
                  font-size: 0.65em;
                  opacity: 0.5;
                }
                a {
                  text-decoration: none;
                  color: ${color.main_dark};
                }
              `}
            >
              {bookingId ? (
                <div
                  css={css`
                    margin-bottom: 1em;
                  `}
                >
                  <p>
                    You have successfully registered for this event with the
                    booking id {bookingId}.
                  </p>
                </div>
              ) : (
                ""
              )}
              <p>
                Although the information below has been curated with the utmost
                attention to every detail, the STARTUP AUTOBAHN team cannot
                guarantee for its flawlesness.
              </p>
              <p>
                If you would like to report mistakes or request changes please
                reach out to{" "}
                <a href="mailto:marketing-ger@pnptc.com">
                  marketing-ger@pnptc.com
                </a>
                .
              </p>
            </div>
          </div>

          <div
            css={css`
              margin-top: 5em;
              padding: 0 0.5em;
              ${mq[2]} {
                margin-top: 0;
                padding: 0;
                flex: 1;
              }
            `}
          >
            {/* <SectionHeading
              title="Description"
              subtitle="An overview of content and participating host/speakers."
              css={css`
                margin-bottom: 2em;
              `}
            />

            <div
              dangerouslySetInnerHTML={{__html: data.agenda_description.childMarkdownRemark.html}} 
              css={css`
                p {
                  margin-bottom: 0;
                  font-size: .9em;
                  &:not(:last-of-type) {
                    margin-bottom: .5em;
                  }
                }
                li {
                  font-size: .9em;
                }
                margin-bottom: 2rem;
              `}
            /> */}

            <Description data={data} />

            <CaseStudy data={data.agenda_casestudies} />

            <Rearview data={publishFilter(data.agenda_rearview, "publish")} />

            {(Flags.features.people === true ||
              Flags.features.people === "profile_only") &&
            data.agenda_host &&
            data.agenda_host.length > 0 &&
            publishFilter(data.agenda_host, "include") &&
            publishFilter(data.agenda_host, "include").length > 0 ? (
              <div>
                <TitleHeader
                  title={`Host${
                    publishFilter(data.agenda_host, "include").length > 1
                      ? "s"
                      : ""
                  } of this session`}
                  icon={<Speaker />}
                  inline
                  size="0.95"
                  css={css`
                    line-height: 1em;
                    padding-top: 1em;
                  `}
                />
                <People people={publishFilter(data.agenda_host, "include")} />
              </div>
            ) : (
              ""
            )}

            {(Flags.features.people === true ||
              Flags.features.people === "profile_only") &&
            data.agenda_speaker &&
            data.agenda_speaker.length > 0 &&
            publishFilter(data.agenda_speaker, "include") &&
            publishFilter(data.agenda_speaker, "include").length > 0 ? (
              <div>
                <TitleHeader
                  title={`Speaker${
                    publishFilter(data.agenda_speaker, "include").length > 1
                      ? "s"
                      : ""
                  } of this session`}
                  icon={<Speaker />}
                  inline
                  size="0.95"
                  css={css`
                    line-height: 1em;
                    padding-top: 1em;
                  `}
                />
                <People
                  people={publishFilter(data.agenda_speaker, "include")}
                />
              </div>
            ) : (
              ""
            )}

            {(Flags.features.people === true ||
              Flags.features.people === "profile_only") &&
            data.agenda_contact &&
            data.agenda_contact.length > 0 &&
            publishFilter(data.agenda_contact, "include") &&
            publishFilter(data.agenda_contact, "include").length > 0 ? (
              <div>
                <TitleHeader
                  title={`Contact`}
                  subtitle={`In case of questions please do not hesitate to get in touch with us.`}
                  icon={<Info />}
                  inline
                  transparent
                  size="0.95"
                  css={css`
                    line-height: 1em;
                    padding-top: 1em;
                  `}
                />

                <Contact
                  people={publishFilter(data.agenda_contact, "include")}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </section>
      </div>
      <RegistrationModal
        registrationOpen={registrationOpen}
        openRegistration={openRegistration}
        handleRegistrationState={handleRegistrationState}
        title={data.agenda_title}
        recordId={recordId}
        limit={data.agenda_attendee_limit}
      />
    </>
  )
}

export default Event
